export default [
    { code: 93, name: "Afghanistan" },
    { code: 358, name: "Aland Islands" },
    { code: 355, name: "Albania" },
    { code: 213, name: "Algeria" },
    { code: 684, name: "American Samoa" },
    { code: 376, name: "Andorra" },
    { code: 244, name: "Angola" },
    { code: 1264, name: "Anguilla" },
    { code: 672, name: "Antarctica" },
    { code: 1268, name: "Antigua and Barbuda" },
    { code: 54, name: "Argentina" },
    { code: 374, name: "Armenia" },
    { code: 297, name: "Aruba" },
    { code: 61, name: "Australia" },
    { code: 43, name: "Austria" },
    { code: 994, name: "Azerbaijan" },
    { code: 1242, name: "Bahamas (The)" },
    { code: 973, name: "Bahrain" },
    { code: 880, name: "Bangladesh" },
    { code: 1246, name: "Barbados" },
    { code: 375, name: "Belarus" },
    { code: 32, name: "Belgium" },
    { code: 501, name: "Belize" },
    { code: 229, name: "Benin" },
    { code: 1441, name: "Bermuda" },
    { code: 975, name: "Bhutan" },
    { code: 591, name: "Bolivia" },
    { code: 387, name: "Bosnia and Herzegovina" },
    { code: 267, name: "Botswana" },
    { code: 47, name: "Bouvet Island" },
    { code: 55, name: "Brazil" },
    { code: 246, name: "British Indian Ocean Territory (the)" },
    { code: 673, name: "Brunei Darussalam" },
    { code: 359, name: "Bulgaria" },
    { code: 226, name: "Burkina Faso" },
    { code: 257, name: "Burundi" },
    { code: 855, name: "Cambodia" },
    { code: 237, name: "Cameroon" },
    { code: 1, name: "Canada" },
    { code: 238, name: "Cape Verde" },
    { code: 1345, name: "Cayman Islands (the)" },
    { code: 236, name: "Central African Republic (the)" },
    { code: 235, name: "Chad" },
    { code: 56, name: "Chile" },
    { code: 86, name: "China" },
    { code: 61, name: "Christmas Island" },
    { code: 61, name: "Cocos (Keeling) Islands (the)" },
    { code: 57, name: "Colombia" },
    { code: 269, name: "Comoros" },
    { code: 242, name: "Congo" },
    { code: 243, name: "Congo (the Democratic Republic of the)" },
    { code: 682, name: "Cook Islands (the)" },
    { code: 506, name: "Costa Rica" },
    { code: 225, name: "Côte d'Ivoire" },
    { code: 385, name: "Croatia" },
    { code: 53, name: "Cuba" },
    { code: 357, name: "Cyprus" },
    { code: 420, name: "Czech Republic (the)" },
    { code: 45, name: "Denmark" },
    { code: 253, name: "Djibouti" },
    { code: 1767, name: "Dominica" },
    { code: 1809, name: "Dominican Republic (the)" },
    { code: 593, name: "Ecuador" },
    { code: 20, name: "Egypt" },
    { code: 503, name: "El Salvador" },
    { code: 240, name: "Equatorial Guinea" },
    { code: 291, name: "Eritrea" },
    { code: 372, name: "Estonia" },
    { code: 251, name: "Ethiopia" },
    { code: 500, name: "Falkland Islands (the) [Malvinas]" },
    { code: 298, name: "Faroe Islands (the)" },
    { code: 679, name: "Fiji" },
    { code: 358, name: "Finland" },
    { code: 33, name: "France" },
    { code: 594, name: "French Guiana" },
    { code: 689, name: "French Polynesia" },
    { code: 262, name: "French Southern Territories (the)" },
    { code: 241, name: "Gabon" },
    { code: 220, name: "Gambia (The)" },
    { code: 995, name: "Georgia" },
    { code: 49, name: "Germany" },
    { code: 233, name: "Ghana" },
    { code: 350, name: "Gibraltar" },
    { code: 30, name: "Greece" },
    { code: 299, name: "Greenland" },
    { code: 1473, name: "Grenada" },
    { code: 590, name: "Guadeloupe" },
    { code: 1671, name: "Guam" },
    { code: 502, name: "Guatemala" },
    { code: 44, name: "Guernsey" },
    { code: 224, name: "Guinea" },
    { code: 245, name: "Guinea-Bissau" },
    { code: 592, name: "Guyana" },
    { code: 509, name: "Haiti" },
    { code: 672, name: "Heard Island and McDonald Islands" },
    { code: 379, name: "Holy See (the) [Vatican City State]" },
    { code: 504, name: "Honduras" },
    { code: 852, name: "Hong Kong" },
    { code: 36, name: "Hungary" },
    { code: 354, name: "Iceland" },
    { code: 91, name: "India" },
    { code: 62, name: "Indonesia" },
    { code: 98, name: "Iran (the Islamic Republic of)" },
    { code: 964, name: "Iraq" },
    { code: 353, name: "Ireland" },
    { code: 44, name: "Isle of Man" },
    { code: 972, name: "Israel" },
    { code: 39, name: "Italy" },
    { code: 1876, name: "Jamaica" },
    { code: 81, name: "Japan" },
    { code: 44, name: "Jersey" },
    { code: 962, name: "Jordan" },
    { code: 73, name: "Kazakhstan" },
    { code: 254, name: "Kenya" },
    { code: 686, name: "Kiribati" },
    { code: 850, name: "Korea (the Democratic People's Republic of)" },
    { code: 82, name: "Korea (the Republic of)" },
    { code: 965, name: "Kuwait" },
    { code: 996, name: "Kyrgyzstan" },
    { code: 856, name: "Lao People's Democratic Republic (the)" },
    { code: 371, name: "Latvia" },
    { code: 961, name: "Lebanon" },
    { code: 266, name: "Lesotho" },
    { code: 231, name: "Liberia" },
    { code: 218, name: "Libyan Arab Jamahiriya (the)" },
    { code: 423, name: "Liechtenstein" },
    { code: 370, name: "Lithuania" },
    { code: 352, name: "Luxembourg" },
    { code: 853, name: "Macao" },
    { code: 389, name: "Macedonia (the former Yugoslav Republic of)" },
    { code: 261, name: "Madagascar" },
    { code: 265, name: "Malawi" },
    { code: 60, name: "Malaysia" },
    { code: 960, name: "Maldives" },
    { code: 223, name: "Mali" },
    { code: 356, name: "Malta" },
    { code: 692, name: "Marshall Islands (the)" },
    { code: 596, name: "Martinique" },
    { code: 222, name: "Mauritania" },
    { code: 230, name: "Mauritius" },
    { code: 269, name: "Mayotte" },
    { code: 52, name: "Mexico" },
    { code: 691, name: "Micronesia (the Federated States of)" },
    { code: 373, name: "Moldova (the Republic of)" },
    { code: 377, name: "Monaco" },
    { code: 976, name: "Mongolia" },
    { code: 382, name: "Montenegro" },
    { code: 1664, name: "Montserrat" },
    { code: 212, name: "Morocco" },
    { code: 258, name: "Mozambique" },
    { code: 95, name: "Myanmar" },
    { code: 264, name: "Namibia" },
    { code: 674, name: "Nauru" },
    { code: 977, name: "Nepal" },
    { code: 31, name: "Netherlands (the)" },
    { code: 599, name: "Netherlands Antilles (the)" },
    { code: 687, name: "New Caledonia" },
    { code: 64, name: "New Zealand" },
    { code: 505, name: "Nicaragua" },
    { code: 227, name: "Niger (the)" },
    { code: 234, name: "Nigeria" },
    { code: 683, name: "Niue" },
    { code: 6723, name: "Norfolk Island" },
    { code: 1670, name: "Northern Mariana Islands (the)" },
    { code: 47, name: "Norway" },
    { code: 968, name: "Oman" },
    { code: 92, name: "Pakistan" },
    { code: 680, name: "Palau" },
    { code: 970, name: "Palestinian Territory (the Occupied)" },
    { code: 507, name: "Panama" },
    { code: 675, name: "Papua New Guinea" },
    { code: 595, name: "Paraguay" },
    { code: 51, name: "Peru" },
    { code: 63, name: "Philippines (the)" },
    { code: 64, name: "Pitcairn" },
    { code: 48, name: "Poland" },
    { code: 351, name: "Portugal" },
    { code: 1809, name: "Puerto Rico" },
    { code: 974, name: "Qatar" },
    { code: 262, name: "Réunion" },
    { code: 40, name: "Romania" },
    { code: 7, name: "Russian Federation (the)" },
    { code: 250, name: "Rwanda" },
    { code: 290, name: "Saint Helena" },
    { code: 1869, name: "Saint Kitts and Nevis" },
    { code: 1758, name: "Saint Lucia" },
    { code: 508, name: "Saint Pierre and Miquelon" },
    { code: 1784, name: "Saint Vincent and the Grenadines" },
    { code: 685, name: "Samoa" },
    { code: 378, name: "San Marino" },
    { code: 239, name: "Sao Tome and Principe" },
    { code: 966, name: "Saudi Arabia" },
    { code: 221, name: "Senegal" },
    { code: 381, name: "Serbia" },
    { code: 248, name: "Seychelles" },
    { code: 232, name: "Sierra Leone" },
    { code: 65, name: "Singapore" },
    { code: 421, name: "Slovakia" },
    { code: 386, name: "Slovenia" },
    { code: 677, name: "Solomon Islands (the)" },
    { code: 252, name: "Somalia" },
    { code: 27, name: "South Africa" },
    { code: 500, name: "South Georgia and the South Sandwich Islands" },
    { code: 34, name: "Spain" },
    { code: 94, name: "Sri Lanka" },
    { code: 249, name: "Sudan (the)" },
    { code: 597, name: "Suriname" },
    { code: 47, name: "Svalbard and Jan Mayen" },
    { code: 268, name: "Swaziland" },
    { code: 46, name: "Sweden" },
    { code: 41, name: "Switzerland" },
    { code: 963, name: "Syrian Arab Republic (the)" },
    { code: 886, name: "Taiwan (Province of China)" },
    { code: 992, name: "Tajikistan" },
    { code: 255, name: "Tanzania,United Republic of" },
    { code: 66, name: "Thailand" },
    { code: 670, name: "Timor-Leste" },
    { code: 228, name: "Togo" },
    { code: 690, name: "Tokelau" },
    { code: 676, name: "Tonga" },
    { code: 1868, name: "Trinidad and Tobago" },
    { code: 216, name: "Tunisia" },
    { code: 90, name: "Turkey" },
    { code: 993, name: "Turkmenistan" },
    { code: 1649, name: "Turks and Caicos Islands (the)" },
    { code: 688, name: "Tuvalu" },
    { code: 256, name: "Uganda" },
    { code: 380, name: "Ukraine" },
    { code: 971, name: "United Arab Emirates (the)" },
    { code: 44, name: "United Kingdom (the)" },
    { code: 1, name: "United States (the)" },
    { code: 1, name: "United States Minor Outlying Islands (the)" },
    { code: 598, name: "Uruguay" },
    { code: 998, name: "Uzbekistan" },
    { code: 678, name: "Vanuatu" },
    { code: 58, name: "Venezuela" },
    { code: 84, name: "Viet Nam" },
    { code: 1284, name: "Virgin Islands (British)" },
    { code: 1340, name: "Virgin Islands (U.S.)" },
    { code: 681, name: "Wallis and Futuna" },
    { code: 212, name: "Western Sahara" },
    { code: 967, name: "Yemen" },
    { code: 260, name: "Zambia" },
    { code: 263, name: "Zimbabwe" }
];
